import { demoDocs } from './demo';
import { DEMO } from '../lib/env';

// Navegador: em vez do SQLite do celular, os documentos ficam no armazenamento do navegador (localStorage).
// Atende só aos comandos que o store.ts usa. Na prévia de demonstração, fica em memória com dados de exemplo.
export type LocalDb = {
  execAsync: (sql: string) => Promise<void>;
  getFirstAsync: <T>(sql: string, ...a: any[]) => Promise<T | null>;
  getAllAsync: <T>(sql: string, ...a: any[]) => Promise<T[]>;
  runAsync: (sql: string, p?: any) => Promise<{ changes: number; lastInsertRowId: number }>;
};
type Row = { id: string; dados: string; versao: number; dirty: number };

const PREFIXO = 'mp:';
const ler = <T,>(k: string, padrao: T): T => { try { const v = localStorage.getItem(PREFIXO + k); return v ? JSON.parse(v) : padrao; } catch { return padrao; } };
const gravar = (k: string, v: unknown) => { try { localStorage.setItem(PREFIXO + k, JSON.stringify(v)); } catch { /* cheio ou bloqueado */ } };

function bancoDemo(): LocalDb {
  const docs: Record<string, Row> = {};
  for (const [id, dados] of Object.entries(demoDocs())) docs[id] = { id, dados: JSON.stringify(dados), versao: 0, dirty: 0 };
  return {
    execAsync: async () => {},
    getFirstAsync: async <T,>(sql: string) => (sql.includes('liberacao')
      ? { value: JSON.stringify({ abas: [], calendarios: ['MS', 'PR', 'SP', 'campo-grande-ms', 'curitiba-pr', 'sao-paulo-sp'], creditos: 10, validade: null, observacao: 'Demonstração', ilimitado: true }) }
      : { value: 'demo' }) as T,
    getAllAsync: async <T,>() => Object.values(docs) as T[],
    runAsync: async (sql: string, p?: any) => {
      if (sql.startsWith('INSERT OR REPLACE INTO docs')) docs[p[0]] = { id: p[0], dados: p[1], versao: p[2], dirty: p[3] };
      return { changes: 1, lastInsertRowId: 0 };
    },
  };
}

function bancoNavegador(): LocalDb {
  let docs = ler<Record<string, Row>>('docs', {});
  let meta = ler<Record<string, string>>('meta', {});
  const salvar = () => { gravar('docs', docs); gravar('meta', meta); };
  const chave = (sql: string) => sql.match(/key\s*=\s*'([^']+)'/)?.[1] ?? sql.match(/VALUES\s*\('([^']+)'/)?.[1];
  return {
    execAsync: async (sql: string) => {
      if (/DELETE FROM docs/.test(sql)) docs = {};
      if (/DELETE FROM meta;/.test(sql)) meta = {};
      else if (/DELETE FROM meta WHERE/.test(sql)) { const k = chave(sql); if (k) delete meta[k]; }
      salvar();
    },
    getFirstAsync: async <T,>(sql: string) => {
      const k = chave(sql);
      return (k && meta[k] != null ? { value: meta[k] } : null) as T | null;
    },
    getAllAsync: async <T,>() => Object.values(docs) as T[],
    runAsync: async (sql: string, p?: any) => {
      if (sql.startsWith('INSERT OR REPLACE INTO docs')) docs[p[0]] = { id: p[0], dados: p[1], versao: p[2], dirty: p[3] };
      else if (sql.startsWith('INSERT OR REPLACE INTO meta')) { const k = chave(sql); if (k) meta[k] = p[0]; }
      salvar();
      return { changes: 1, lastInsertRowId: 0 };
    },
  };
}

export async function openLocal(): Promise<LocalDb> {
  return DEMO || typeof localStorage === 'undefined' ? bancoDemo() : bancoNavegador();
}
